import { ReactNode } from 'react';
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';

import { Box } from 'src/components/Box';
import { Text } from 'src/components/Text';
import { Margins, Responsive } from 'src/design-system/style-types';

import { style } from './Radio.style';

interface Props {
  name: string;
  onChange: (params: { name: string }) => void;
  label?: ReactNode;
  checked?: boolean;
  disabled?: boolean;
  checkedName?: string;
  help?: ReactNode;
  marginTop?: Responsive<Margins>;
  marginBottom?: Responsive<Margins>;
}

export const Radio = ({
  name,
  label,
  onChange,
  checked = false,
  disabled = false,
  checkedName = '',
  help = undefined,
  marginBottom = 'lg',
  marginTop = '0',
}: Props) => {
  const textColor = disabled ? 'grey' : undefined;

  return (
    <label
      css={style.container({ marginBottom, marginTop, disabled })}
      role="radio"
      aria-checked={checked || checkedName === name}
      aria-disabled={disabled}
      onClick={() => !disabled && onChange({ name })}
      tabIndex={disabled ? -1 : 0}
      onKeyDown={(e) => {
        if (e.key !== ' ' && e.key !== 'Enter') {
          return;
        }

        e.preventDefault();
        onChange({ name });
      }}
    >
      <Box d="column">
        {label && (
          <Text color={textColor} tag="span">
            {label}
          </Text>
        )}

        {help && (
          <Text size="sm" color="grey" data-qa="help">
            {help}
          </Text>
        )}
      </Box>

      <span className="checkmark" />
    </label>
  );
};
